<div class="help-hub" [class.is-open]="isOpen()">
  <button
    type="button"
    class="help-hub-trigger"
    data-testid="help-hub-trigger"
    [attr.aria-expanded]="isOpen()"
    aria-haspopup="dialog"
    (click)="toggle()"
    uiTooltip
    [tooltipText]="'MENU.HELP' | transloco"
    [tooltipPosition]="'bottom'">
    <ui-inline-svg name="help"></ui-inline-svg>
  </button>

  @if (isOpen()) {
    <div class="help-hub-panel" role="dialog" data-testid="help-hub-panel" aria-labelledby="help-hub-title">
      <header class="help-hub-header">
        @if (view() === 'contact') {
          <button
            type="button"
            class="help-hub-back"
            data-testid="help-hub-back"
            [attr.aria-label]="'HELP_HUB.BACK' | transloco"
            (click)="backToMenu()">
            <ui-inline-svg name="arrow-left"></ui-inline-svg>
          </button>
        }
        <h2 id="help-hub-title" class="help-hub-title">
          {{ (view() === 'contact' ? 'HELP_HUB.CONTACT.TITLE' : 'HELP_HUB.TITLE') | transloco }}
        </h2>
      </header>

      @if (view() === 'menu') {
        <div class="help-hub-body">
          @for (section of sections; track section.id) {
            <section class="help-hub-section" [attr.data-section]="section.id">
              <p class="help-hub-section-title">{{ section.titleKey | transloco }}</p>

              @for (item of section.items; track item.id) {
                @if (item.action === 'internal') {
                  <button
                    type="button"
                    class="help-hub-item"
                    [attr.data-testid]="'help-hub-item-' + item.id"
                    (click)="onItemClick(item)">
                    <ui-inline-svg class="help-hub-item-icon" [name]="item.icon"></ui-inline-svg>
                    <span class="help-hub-item-text">
                      <span class="help-hub-item-title">{{ item.titleKey | transloco }}</span>
                      <span class="help-hub-item-description">{{ item.descriptionKey | transloco }}</span>
                    </span>
                    <ui-inline-svg class="help-hub-item-action" name="arrow-right"></ui-inline-svg>
                  </button>
                } @else {
                  <a
                    class="help-hub-item"
                    [attr.data-testid]="'help-hub-item-' + item.id"
                    [href]="resolveItemUrl(item)"
                    [attr.target]="item.action === 'external' ? '_blank' : null"
                    [attr.rel]="item.action === 'external' ? 'noopener noreferrer' : null"
                    (click)="onItemClick(item)">
                    <ui-inline-svg class="help-hub-item-icon" [name]="item.icon"></ui-inline-svg>
                    <span class="help-hub-item-text">
                      <span class="help-hub-item-title">{{ item.titleKey | transloco }}</span>
                      <span class="help-hub-item-description">{{ item.descriptionKey | transloco }}</span>
                    </span>
                    <ui-inline-svg class="help-hub-item-action" name="external-link"></ui-inline-svg>
                  </a>
                }
              }
            </section>
          }
        </div>
      }
      <!-- TODO(INS-2269): In-app contact form popup disabled until the support backend is ready.
        When re-enabling, add SelectFieldComponent, TextAreaFieldComponent and ButtonComponent back to the component imports.
        <div class="help-hub-body help-hub-contact">
          @if (submitted()) {
            <div class="help-hub-success" data-testid="help-hub-contact-success">
              <ui-inline-svg class="help-hub-success-icon" name="check"></ui-inline-svg>
              <p class="help-hub-success-title">{{ 'HELP_HUB.CONTACT.SUCCESS.TITLE' | transloco }}</p>
              <p class="help-hub-success-text">{{ 'HELP_HUB.CONTACT.SUCCESS.TEXT' | transloco }}</p>
              <ui-button [centered]="true" (click)="backToMenu()">
                {{ 'HELP_HUB.CONTACT.SUCCESS.DONE' | transloco }}
              </ui-button>
            </div>
          } @else {
            <p class="help-hub-contact-intro">{{ 'HELP_HUB.CONTACT.INTRO' | transloco }}</p>

            <div class="help-hub-field">
              <label class="help-hub-label">{{ 'HELP_HUB.CONTACT.SUBJECT_LABEL' | transloco }}</label>
              <ui-select-field
                class="help-hub-select"
                data-testid="help-hub-contact-subject"
                [options]="subjectOptions()"
                [value]="contactSubject()"
                [placeholder]="'HELP_HUB.CONTACT.SUBJECT_PLACEHOLDER' | transloco"
                (valueChange)="contactSubject.set($any($event))"></ui-select-field>
              @if (subjectInvalid()) {
                <span class="help-hub-field-error">{{ 'HELP_HUB.CONTACT.SUBJECT_REQUIRED' | transloco }}</span>
              }
            </div>

            <div class="help-hub-field">
              <label class="help-hub-label">{{ 'HELP_HUB.CONTACT.MESSAGE_LABEL' | transloco }}</label>
              <ui-text-area-field
                class="help-hub-textarea"
                data-testid="help-hub-contact-message"
                [(value)]="contactMessage"
                [state]="messageState()"
                [alert]="messageInvalid() ? ('HELP_HUB.CONTACT.MESSAGE_REQUIRED' | transloco) : ''"
                [placeholder]="'HELP_HUB.CONTACT.MESSAGE_PLACEHOLDER' | transloco"></ui-text-area-field>
            </div>

            <div class="help-hub-field">
              @if (attachedFile()) {
                <div class="help-hub-attachment" data-testid="help-hub-attachment">
                  <ui-inline-svg class="help-hub-attachment-icon" name="paperclip"></ui-inline-svg>
                  <span class="help-hub-attachment-name">{{ attachedFile()?.name }}</span>
                  <button
                    type="button"
                    class="help-hub-attachment-remove"
                    [attr.aria-label]="'HELP_HUB.CONTACT.REMOVE_FILE' | transloco"
                    (click)="removeFile()">
                    <ui-inline-svg name="close-btn"></ui-inline-svg>
                  </button>
                </div>
              } @else {
                <label class="help-hub-attach" data-testid="help-hub-attach">
                  <input
                    type="file"
                    class="help-hub-attach-input"
                    [accept]="acceptedFileTypes"
                    (change)="onFileChange($event)" />
                  <ui-inline-svg class="help-hub-attach-icon" name="paperclip"></ui-inline-svg>
                  <span class="help-hub-attach-label">{{ 'HELP_HUB.CONTACT.ATTACH' | transloco }}</span>
                  <span class="help-hub-attach-optional">{{ 'HELP_HUB.CONTACT.OPTIONAL' | transloco }}</span>
                </label>
              }
              @if (attachError()) {
                <span class="help-hub-field-error" data-testid="help-hub-attach-error">{{ attachError() }}</span>
              }
            </div>

            @if (submitFailed()) {
              <p class="help-hub-field-error" data-testid="help-hub-contact-error">
                {{ 'HELP_HUB.CONTACT.ERROR' | transloco }}
              </p>
            }

            @if (!contactEnabled) {
              <p class="help-hub-contact-note" data-testid="help-hub-contact-disabled">
                {{ 'HELP_HUB.CONTACT.DISABLED_NOTE' | transloco }}
              </p>
            }

            <div class="help-hub-contact-actions">
              <ui-button [secondary]="true" [disabled]="submitting()" (click)="backToMenu()">
                {{ 'HELP_HUB.CONTACT.CANCEL' | transloco }}
              </ui-button>
              <ui-button
                data-testid="help-hub-contact-submit"
                [loading]="submitting()"
                [disabled]="!contactEnabled"
                (click)="onSubmitContact()">
                {{ 'HELP_HUB.CONTACT.SEND' | transloco }}
              </ui-button>
            </div>
          }
        </div>
      -->
    </div>
  }
</div>
